<button #notificationOrigin mat-icon-button (click)="openPanel()" [matTooltip]="'Notifications'">
  <mat-icon class="icon-size-6 dark:text-white" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
  @if (unreadCounts() > 0) {
    <span class="absolute right-2.5 top-2 h-2 w-2 rounded-full bg-primary"></span>
  }
</button>

<ng-template #notificationPanel>
  <div
    class="notifications-panel bg-card fixed inset-0 flex flex-col gap-3 overflow-hidden shadow-[0_0_4px_0_rgba(0,0,0,0.25)] sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl">
    <header class="flex h-[62px] w-full items-center justify-between px-6">
      <h1 class="text-xl font-bold">Notifications</h1>
      <button mat-icon-button class="hidden sm:inline-flex" (click)="settings()">
        <mat-icon class="text-slate-500 icon-size-6" [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
      </button>
      <button mat-icon-button class="inline-flex sm:hidden" (click)="overlayRef?.detach()">
        <mat-icon class="text-slate-500 icon-size-6" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </header>
    <mat-tab-group class="h-12" [selectedIndex]="tab()" (selectedIndexChange)="onTabChange($event)" [dynamicHeight]="false" [mat-stretch-tabs]="false">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="{{ tab() === 0 ? 'text-primary' : 'text-slate-500' }}">All</span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex items-center gap-2">
            <span class="{{ tab() === 1 ? 'text-primary' : 'text-slate-500' }}">Inbox</span>
            @if (unreadCounts() > 0) {
              <span class="inline-flex h-6 items-center justify-center rounded-xl bg-primary px-2 text-white">
                <span>{{ unreadCounts() > 99 ? '99+' : unreadCounts() }}</span>
              </span>
            }
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="{{ tab() === 2 ? 'text-primary' : 'text-slate-500' }}">Archived</span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    @if (notificationsItems()?.length) {
      <nav class="flex h-10 w-full items-center justify-end px-6">
        @if (tab() !== 2) {
          <span class="text-md font-medium text-primary underline hover:cursor-pointer" (click)="readAll()">Mark all as read</span>
        }
      </nav>
      <main class="h-[267px] w-full pb-4">
        <app-infinite-scroll
          class="h-full overflow-y-hidden"
          [containerHeight]="'h-full'"
          [isLoading]="isLoading()"
          [conditionToStopLoading]="conditionToStopLoading()"
          (onScrollEvent)="onScroll()"
          [alwaysCallback]="true">
          @for (f of notificationsItems(); track f?.id) {
            <article
              #notificationItemElement
              class="group relative flex h-[62px] w-full flex-col justify-center gap-1 px-6 hover:cursor-pointer {{ !$last ? 'mb-px' : '' }} {{
                !f.read_at && !f.hidden_at ? 'border-l-[1.5px] border-l-primary bg-blue-50' : 'hover:bg-slate-100'
              }}"
              (click)="!f.hidden_at && read(f)">
              <p
                class="font-semibold {{ !f.read_at && !f.hidden_at ? 'text-primary' : 'text-slate-600' }} {{
                  tab() === 0 && f.hidden_at ? 'opacity-60 line-through' : ''
                }}">
                {{ f.notification?.title || '-' }}
              </p>
              <p class="{{ !f.read_at && !f.hidden_at ? 'text-primary' : 'text-slate-500' }} {{ tab() === 0 && f.hidden_at ? 'opacity-60 line-through' : '' }}">
                {{ f.notification?.body || '-' }}
              </p>
              <div
                class="pointer-events-none absolute right-3 top-1/2 flex -translate-y-1/2 transform items-center opacity-0 transition duration-150 ease-in-out group-focus-within:pointer-events-auto group-focus-within:opacity-100 group-hover:pointer-events-auto group-hover:-translate-y-1/2 group-hover:opacity-100">
                <button
                  mat-icon-button
                  aria-label="Hide/Unhide notification"
                  (click)="f.hidden_at ? unhide(f, $event) : hide(f, $event); notificationItemElement.blur()">
                  <mat-icon class="icon-size-5" [svgIcon]="f.hidden_at ? 'heroicons_outline:eye' : 'heroicons_outline:eye-slash'"></mat-icon>
                </button>
                <button mat-icon-button aria-label="Delete notification" (click)="delete(f, $event); notificationItemElement.blur()">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                </button>
              </div>
              @if (!f.read_at && !f.hidden_at) {
                <span class="absolute right-4 top-3 h-2 w-2 rounded-full bg-primary"></span>
              }
            </article>
          }
        </app-infinite-scroll>
      </main>
    } @else {
      <div class="text-muted flex h-[307px] w-full items-center justify-center text-sm">No Notification</div>
    }
  </div>
</ng-template>
